import React, { useState, useEffect } from 'react';
import LoginScreen from './screens/LoginScreen';
import ChangePassword from './screens/ChangePassword';
import MainApp from './screens/MainApp';
import { jwtDecode } from "jwt-decode";

// 🔍 Validar token
const isTokenValid = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

export default function App() {

  const [token, setToken] = useState(() => {
    const t = localStorage.getItem('token');
    return t && isTokenValid(t) ? t : null;
  });

  const [currentUser, setCurrentUser] = useState(() => {
    const t = localStorage.getItem('token');
    const user = localStorage.getItem('currentUser');

    if (t && isTokenValid(t) && user) {
      try {
        return JSON.parse(user);
      } catch {
        return null;
      }
    }
    return null;
  });

  const [debecambiar, setDebecambiar] = useState(() => {
    return localStorage.getItem('debecambiar') === 'true';
  });

  // 🔥 Si el token ya expiró al montar
  useEffect(() => {
    if (token && !isTokenValid(token)) {
      handleLogout();
    }
  }, []);

  const handleLogin = (session) => {
    setCurrentUser(session.user);
    setToken(session.token);
    setDebecambiar(session.debe_cambiar_password);

    localStorage.setItem('currentUser', JSON.stringify(session.user));
    localStorage.setItem('token', session.token);
    localStorage.setItem('debecambiar', session.debe_cambiar_password);
  };

  const handleLogout = () => {
    setCurrentUser(null);
    setToken(null);
    setDebecambiar(false);

    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    localStorage.removeItem('debecambiar');
  };

  // 🧠 Render inteligente
  if (!token || !currentUser) {
    return <LoginScreen onLogin={handleLogin} />;
  }

  if (debecambiar) {
    return <ChangePassword token={token} onDone={handleLogout} />;
  }

  return (
    <MainApp
      currentUser={currentUser}
      token={token}
      onLogout={handleLogout}
    />
  );
}